import { createSelector } from 'reselect';
 
const selectEventBookings = (state: any) => state.eventBookings;


export const selectEventBookingsCurrentItem = createSelector([selectEventBookings], (eventBookings) => eventBookings.current);

export const selectEventBookingsListItems = createSelector([selectEventBookings], (eventBookings) => eventBookings.list);

export const selectEventBookingsItemById = (itemId: any) =>
    createSelector(selectEventBookingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
export const selectEventBookingsQueryItems = createSelector([selectEventBookings], (eventBookings) => eventBookings.query);

export const selectEventBookingsCreatedItem = createSelector([selectEventBookings], (eventBookings) => eventBookings.create);

export const selectEventBookingsUpdatedItem = createSelector([selectEventBookings], (eventBookings) => eventBookings.update);

export const selectEventBookingsReadItem = createSelector([selectEventBookings], (eventBookings) => eventBookings.read);

export const selectEventBookingsDeletedItem = createSelector([selectEventBookings], (eventBookings) => eventBookings.delete);

export const selectEventBookingsSearchedItems = createSelector([selectEventBookings], (eventBookings) => eventBookings.search);

export const selectEventBookingsItemsCount = createSelector([selectEventBookings], (eventBookings) => eventBookings.count);

export const selectEventBookingsItemsFilter = createSelector([selectEventBookings], (eventBookings) => eventBookings.filter);